//core
import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@mui/material";

//icons
import { MoreVert as MoreVertIcon, Edit, Delete } from "@mui/icons-material";
import { PaymentIcon } from "../../../../../../../../UI/Icons";

//styles
import { useStyles } from "./styles";

//hooks
import { usePermissions } from "../../../../../../../../../store/common/configuration/usePermissions";
import { useFlatFee } from "../../../../../../../../../store/admin/flatFee/useFlatFee";

//components
import MuiModal from "../../../../../../../../UI/MuiModal";

import CreateUpdatePayout from "../../../CreateUpdatePayout";
import Payouts from "../../../../index";
import { usePayoutsContext } from "../../../../PayoutsContext";


export interface ICardMenuProps {
  id: any;
  data: any;
  affiliateId: number;
  flatFeeId: number;
  paymentData: any;
}

const CardMenu: React.FC<ICardMenuProps> = (props): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { hasPermissions } = usePermissions();

  const context = usePayoutsContext();

  const { data, affiliateId, flatFeeId, paymentData } = props;

  const { removePayout } = useFlatFee();

  const isPermissionShowEdit = hasPermissions(["api3.admin.flatfeecontroller.payment_edit"]);
  const isPermissionShowDelete = hasPermissions(["api3.admin.flatfeecontroller.payment_delete"]);

  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, [setAnchorEl]);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  },[setAnchorEl]);

  const handleDelete = () => {
    handleClose();

    removePayout({
      paymentId: data.id
    });
  }

  const handleToggleEditModal = useCallback((state: boolean) => {
    context.setDataCreateUpdatePayout(data);
    setShowEditModal(state);
    handleClose();
  },[setShowEditModal, data]);

  return (
    <>
      {!!data && (
        <>
          <Button
            className={`${styles.button} ${ open ? styles.active : ''}`}
            color="secondary"
            onClick={handleClick}
            id="link-card-menu"
            aria-controls={open ? 'basic-card-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <MoreVertIcon className={styles.icon} />
          </Button>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{ 'aria-labelledby': 'link-card-menu' }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >

            {isPermissionShowDelete && (
              <MenuItem disabled={paymentData.status.toLowerCase() === "annulated" || paymentData.status.toLowerCase() === "closed"} onClick={handleDelete} className={styles.item}>
                <Delete className={styles.icon} fontSize="small" color={'primary'} sx={{ marginRight: '16px' }}/>
                {t("common.buttons.delete")}
              </MenuItem>
            )}

            {
              isPermissionShowEdit && (
                <MenuItem disabled={paymentData.status.toLowerCase() === "annulated" || paymentData.status.toLowerCase() === "closed"} onClick={() => handleToggleEditModal(true)} className={styles.item}>
                  <Edit className={styles.icon} fontSize="small" color={'primary'} sx={{ marginRight: '16px' }} />
                  {t("common.buttons.edit")}
                </MenuItem>
              )
            }
          </Menu>
          <MuiModal
            width={505}
            open={showEditModal}
            closeOnOutside={false}
            setToggleModal={setShowEditModal}
          >
            <CreateUpdatePayout
              data={data}
              closeModal={handleToggleEditModal}
              affiliateId={affiliateId}
              flatFeeId={flatFeeId}
            />
          </MuiModal>
        </>
      )}
    </>
  );
};

export default CardMenu;
